var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalGlyphGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 91.5 92",
    style: {
      enableBackground: "new 0 0 91.5 92"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#fff;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.3,21.1C63.8,14.6,55.1,11,45.9,11c-19,0-34.5,15.5-34.6,34.6c0,6.1,1.6,12,4.6,17.3L11,80.7l18.3-4.8 c5,2.8,10.7,4.2,16.5,4.2h0c19,0,34.5-15.5,34.6-34.6C80.4,36.3,76.9,27.7,70.3,21.1L70.3,21.1z M45.9,74.3L45.9,74.3 c-5.2,0-10.2-1.4-14.6-4l-1-0.6l-10.9,2.9l2.9-10.6l-0.7-1.1c-2.9-4.6-4.4-9.9-4.4-15.3c0-15.8,12.9-28.7,28.7-28.7 c7.7,0,14.9,3,20.3,8.4c5.4,5.4,8.4,12.6,8.4,20.3C74.6,61.4,61.7,74.3,45.9,74.3L45.9,74.3z M61.6,52.8c-0.9-0.4-5.1-2.5-5.9-2.8 c-0.8-0.3-1.4-0.4-1.9,0.4c-0.6,0.9-2.2,2.8-2.7,3.4c-0.5,0.6-1,0.6-1.9,0.2c-0.9-0.4-3.6-1.3-6.9-4.3c-2.6-2.3-4.3-5.1-4.8-6 c-0.5-0.9-0.1-1.3,0.4-1.8c0.4-0.4,0.9-1,1.3-1.5c0.4-0.5,0.6-0.9,0.9-1.4c0.3-0.6,0.1-1.1-0.1-1.5c-0.2-0.4-1.9-4.7-2.7-6.4 c-0.7-1.7-1.4-1.5-1.9-1.5c-0.5,0-1.1,0-1.7,0c-0.6,0-1.5,0.2-2.3,1.1c-0.8,0.9-3,3-3,7.2s3.1,8.4,3.5,8.9c0.4,0.6,6.1,9.3,14.7,13 c2.1,0.9,3.7,1.4,4.9,1.8c2.1,0.7,4,0.6,5.4,0.3c1.7-0.2,5.1-2.1,5.8-4.1c0.7-2,0.7-3.7,0.5-4.1C63.1,53.4,62.5,53.2,61.6,52.8 L61.6,52.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalGlyphGreen);
export default __webpack_public_path__ + "static/media/Digital_Glyph_Green.424267eaf23b4f57cc7ae175463135fe.svg";
export { ForwardRef as ReactComponent };